/* ==========================================================================
   Planetry Prints · the bag
   --------------------------------------------------------------------------
   1. Thumbnails: every line shows the design for that order.
      The Date Print draws the real arrangement for its date with the shared
      engine (pp-orrery.js). The Sky Code Case draws its nine bars as a small
      SVG of the case back, laid out exactly as the case studio's drawSkyCode
      (pp-case-customizer.js), with the orbit figures from pp-skycode.js.
      Both engines load only when a line needs them, and lines re-draw after
      Dawn re-renders the drawer or the cart page.
   2. Studios: after Add to cart, the bag drawer opens with the fresh bag
      instead of a trip to /cart. If anything fails, it goes to /cart.
   Spec: site-redesign-2026-10-09/DESIGN-PLAN.md 5.3.
   ========================================================================== */
(function (global) {
  'use strict';

  /* ---- the Sky Code, as the case prints it --------------------------------
     Design units: a thousandth of the case back's width (its safe line), the
     same units drawSkyCode uses, so one layout fits every phone. */
  var PLANETS = ['mercury', 'venus', 'earth', 'mars', 'jupiter', 'saturn', 'uranus', 'neptune', 'pluto'];
  var LETTERS = ['M', 'V', 'E', 'M', 'J', 'S', 'U', 'N', 'P'];
  var EDITION = {
    black: { bg: '#050505', ink: '#f2f0ec', earth: '#11abe9', well: ['#202224', '#121518'] },
    white: { bg: '#ffffff', ink: '#111111', earth: '#11abe9', well: ['#e1e3e2', '#bfc3c5'] }
  };
  var SUN_YELLOW = '#f9b700';
  var BOLD = 0.075;
  var RAIL_LABEL = 'ONE FULL ORBIT';
  var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July',
    'August', 'September', 'October', 'November', 'December'];

  /* Per phone: the safe area's height (per 1000 of width) and the camera
     cut-out's box [x0, y0, x1, y1] in the same units, from the studio's
     Printful templates. Unknown models fall back to DEFAULT_MODEL. */
  var MODELS = {"iphone-18-pro-max":[2011,55,48,945,577],"iphone-18-pro":[1997,60,51,940,622],"iphone-17-pro-max":[2011,55,48,945,577],"iphone-17-pro":[1997,60,51,940,622],"iphone-17-air":[2001,54,48,946,417],"iphone-17":[2003,48,43,514,602],"iphone-16-pro-max":[2011,41,23,572,566],"iphone-16-pro":[1995,46,24,620,611],"iphone-16-plus":[1996,34,23,471,552],"iphone-16":[1988,33,21,508,599],"iphone-15-pro-max":[2065,13,7,580,593],"iphone-15-pro":[2065,17,10,632,647],"iphone-15-plus":[2053,1,-7,480,472],"iphone-15":[2053,11,-1,522,509],"iphone-14-pro-max":[2065,13,7,580,593],"iphone-14-pro":[2067,17,10,632,647],"iphone-14-plus":[2053,1,-7,480,472],"iphone-14":[2055,-9,-12,511,507],"iphone-13-pro-max":[1991,26,24,556,555],"iphone-13-pro":[1977,28,27,605,602],"iphone-13":[1980,30,23,502,493],"iphone-13-mini":[1962,25,13,539,530],"iphone-12-pro-max":[1989,42,35,517,539],"iphone-12-pro":[1971,45,35,506,524],"iphone-12":[1972,46,38,505,525],"iphone-12-mini":[1964,47,36,489,533],"iphone-11-pro-max":[1968,31,19,464,479],"iphone-11-pro":[1952,34,18,504,518],"iphone-11":[1931,44,31,454,483],"galaxy-s26-ultra":[2136,12,9,529,824],"galaxy-s26-plus":[2136,7,2,457,762],"galaxy-s26":[2132,14,8,490,806],"galaxy-s25-ultra":[2144,-2,-6,513,825],"galaxy-s25-plus":[2144,-13,-18,442,784],"galaxy-s25":[2140,-9,-14,464,806],"galaxy-s24-ultra":[2131,10,-23,515,787],"galaxy-s24-plus":[2099,-1,-2,427,779],"galaxy-s24":[2098,14,-2,459,780],"galaxy-s23-ultra":[2131,10,-23,515,787],"galaxy-s23-plus":[2097,5,-1,437,739],"galaxy-s23":[2073,10,6,479,790],"galaxy-s22-ultra":[2142,39,10,495,737],"galaxy-s22-plus":[2105,-23,-28,436,696],"galaxy-s22":[2093,-24,-27,460,743],"galaxy-s21-ultra":[2210,-18,-31,530,789],"galaxy-s21-plus":[2160,-20,-34,464,670],"galaxy-s21":[2124,-16,-31,477,703],"galaxy-s21-fe":[2086,-19,-28,474,709],"galaxy-s20-ultra":[2242,30,30,578,772],"galaxy-s20-plus":[2227,31,20,430,620],"galaxy-s20":[2227,35,23,402,652],"galaxy-s20-fe":[2155,31,19,405,663]};
  var DEFAULT_MODEL = 'iphone-17-pro';

  function modelGeometry(key) {
    var k = String(key || '').split('/').pop();
    var m = MODELS[k] || MODELS[DEFAULT_MODEL];
    return { bh: m[0], camera: [m[1], m[2], m[3], m[4]] };
  }

  function validCaseDate(iso) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(iso || '') || iso < '1900-01-01' || iso > '2050-12-31') return false;
    var d = new Date(iso + 'T12:00:00Z');
    return isFinite(d.getTime()) && d.toISOString().slice(0, 10) === iso;
  }

  function caseDateText(iso) {
    var p = iso.split('-');
    return (+p[2]) + ' ' + MONTHS[+p[1] - 1].toUpperCase() + ' ' + p[0];
  }

  /* The code block's geometry for one date, from drawSkyCode with u = 1 and
     the safe area at the origin. `days` is orbitDays(date): { planet: {frac} }.
     'exact' scale (what the studio sells): a bar's height is its share of the
     orbit, never shorter than its own width (then it is a round dot). */
  function skyLayout(days, bh, planets) {
    planets = planets || PLANETS;
    var cx = 500, pitch = 76;
    var st = 7, w = 30, gap = 10;
    var mid = 0.645 * bh;
    var T = mid - 195, B = mid + 195;
    var lo = T + st / 2 + gap, hi = B - st / 2 - gap, full = hi - lo;
    var xs = planets.map(function (_, k) { return cx + (k - 4) * pitch; });
    var bars = planets.map(function (p, k) {
      var frac = days[p].frac;
      var h = Math.max(frac * full, w);
      var top = hi - h;
      var dot = h - w < 0.01;
      return {
        planet: p, x: xs[k], h: h, dot: dot,
        /* a dot: circle at (x, cy) radius w/2; a bar: round-capped line y1..y2 */
        cy: hi - w / 2, r: w / 2,
        y1: top + w / 2, y2: top + h - w / 2
      };
    });
    return {
      cx: cx, xs: xs, st: st, w: w, T: T, B: B, lo: lo, hi: hi, full: full, bars: bars,
      iniY: B + 70, dateY: T - 64, sunY: 0.866 * bh, sunR: 56,
      x0: xs[0] - 34, x1: xs[xs.length - 1] + 34
    };
  }

  var measureCtx = null;
  function textWidth(s, size, spacing) {
    var width = s.length * size * 0.62;
    try {
      measureCtx = measureCtx || global.document.createElement('canvas').getContext('2d');
      measureCtx.font = Math.round(size * 4) + "px PPGlacial, 'Glacial Indifference', sans-serif";
      width = measureCtx.measureText(s).width / 4;
    } catch (_) { /* keep the estimate */ }
    return width + (spacing || 0) * Math.max(0, s.length - 1);
  }

  function f2(v) { return v.toFixed(2); }
  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }

  /* The case back as an SVG string: the rounded case, the camera cut-out,
     the date between its rules, the two rails, the bars, the initials and
     the Sun. Iteration 3: a clean ground, no stars. */
  function caseSVG(opts) {
    var e = EDITION[opts.edition === 'white' ? 'white' : 'black'];
    var g = modelGeometry(opts.model);
    var bh = g.bh;
    var L = skyLayout(opts.days, bh, opts.planets);
    /* The case prints Earth in its own blue (#11abe9), not the site token. */
    var earthBlue = opts.earth || e.earth;
    var ink = e.ink;
    var out = [];
    var pad = 46, r = 150;
    var id = 'ppcase' + (++caseCount);
    var font = "PPGlacial, 'Glacial Indifference', sans-serif";

    function type(x, y, text, size, track) {
      track = track || 0;
      out.push('<text x="' + f2(x + track / 2) + '" y="' + f2(y) + '" font-family="' + font + '" font-size="' + f2(size) +
        '" fill="' + ink + '" text-anchor="middle" letter-spacing="' + f2(track) + '" stroke="' + ink +
        '" stroke-width="' + f2(size * BOLD) + '" stroke-linejoin="round">' + esc(text) + '</text>');
    }
    function hline(y, gaps) {
      var a = L.x0;
      var list = (gaps || []).slice().sort(function (p, q) { return p[0] - q[0]; }).concat([[L.x1 + 1e6, 0]]);
      for (var i = 0; i < list.length; i++) {
        var b = Math.min(list[i][0] - list[i][1], L.x1);
        if (b > a) out.push('<line x1="' + f2(a) + '" y1="' + f2(y) + '" x2="' + f2(b) + '" y2="' + f2(y) +
          '" stroke="' + ink + '" stroke-width="' + f2(L.st) + '" stroke-linecap="round"/>');
        a = Math.max(a, list[i][0] + list[i][1]);
      }
    }

    out.push('<svg xmlns="http://www.w3.org/2000/svg" viewBox="' + [-pad - 4, -pad - 4, 1000 + 2 * pad + 8, bh + 2 * pad + 8].join(' ') +
      '" preserveAspectRatio="xMidYMid meet" aria-hidden="true" focusable="false">');
    out.push('<defs><linearGradient id="' + id + '-well" x2=".8" y2="1"><stop stop-color="' + e.well[0] +
      '"/><stop offset="1" stop-color="' + e.well[1] + '"/></linearGradient></defs>');
    /* the case */
    out.push('<rect x="' + (-pad) + '" y="' + (-pad) + '" width="' + (1000 + 2 * pad) + '" height="' + (bh + 2 * pad) +
      '" rx="' + r + '" fill="' + e.bg + '" stroke="' + (opts.edition === 'white' ? 'rgba(28,33,39,0.22)' : 'rgba(28,33,39,0.5)') +
      '" stroke-width="5"/>');
    /* the camera cut-out */
    var c = g.camera, cw = c[2] - c[0], ch = c[3] - c[1];
    var cr = Math.min(cw, ch) * 0.3;
    out.push('<rect x="' + Math.max(c[0], -pad + 24) + '" y="' + Math.max(c[1], -pad + 24) + '" width="' + cw + '" height="' + ch +
      '" rx="' + f2(cr) + '" fill="url(#' + id + '-well)"/>');

    /* initials under the start line */
    for (var k = 0; k < LETTERS.length; k++) type(L.xs[k], L.iniY, LETTERS[k], 29);
    /* the two rails; ONE FULL ORBIT set into the top one */
    hline(L.T, [[L.cx, textWidth(RAIL_LABEL, 23, 5) / 2 + 18]]);
    hline(L.B);
    /* the bars stand on the start line */
    for (var b = 0; b < L.bars.length; b++) {
      var bar = L.bars[b], fill = bar.planet === 'earth' ? earthBlue : ink;
      if (bar.dot) out.push('<circle cx="' + f2(bar.x) + '" cy="' + f2(bar.cy) + '" r="' + f2(bar.r) + '" fill="' + fill + '"/>');
      else out.push('<line x1="' + f2(bar.x) + '" y1="' + f2(bar.y1) + '" x2="' + f2(bar.x) + '" y2="' + f2(bar.y2) +
        '" stroke="' + fill + '" stroke-width="' + f2(L.w) + '" stroke-linecap="round"/>');
    }
    type(L.cx, L.T + 23 * 0.36, RAIL_LABEL, 23, 5);
    /* the Sun */
    out.push('<circle cx="' + f2(L.cx) + '" cy="' + f2(L.sunY) + '" r="' + L.sunR + '" fill="' + SUN_YELLOW + '"/>');
    /* the date between two short rules */
    var dateText = caseDateText(opts.date);
    var size = 37, spacing = 6, th = 3;
    type(L.cx, L.dateY, dateText, size, spacing);
    var tw = textWidth(dateText, size, spacing), dgap = size * 0.55, dash = size * 0.9, dmid = L.dateY - size * 0.3;
    [-1, 1].forEach(function (sgn) {
      var a = L.cx + sgn * (tw / 2 + dgap), z = a + sgn * dash;
      out.push('<rect x="' + f2(Math.min(a, z)) + '" y="' + f2(dmid - th / 2) + '" width="' + f2(Math.abs(z - a)) +
        '" height="' + f2(th) + '" fill="' + ink + '"/>');
    });
    out.push('</svg>');
    return out.join('');
  }
  var caseCount = 0;

  var api = {
    PLANETS: PLANETS, LETTERS: LETTERS, MODELS: MODELS,
    skyLayout: skyLayout, caseSVG: caseSVG, modelGeometry: modelGeometry,
    validCaseDate: validCaseDate, caseDateText: caseDateText
  };

  /* Node (the standalone test) gets the pure functions and stops here. */
  if (typeof module !== 'undefined' && module.exports && typeof global.document === 'undefined') {
    module.exports = api;
    return;
  }

  var doc = global.document;
  var PPBag = global.PPBag = global.PPBag || {};
  if (PPBag.booted) return;
  PPBag.booted = true;
  for (var key in api) PPBag[key] = api[key];

  function root() {
    return (global.Shopify && global.Shopify.routes && global.Shopify.routes.root) || '/';
  }
  function cartUrl() {
    return (global.routes && global.routes.cart_url) || root() + 'cart';
  }

  /* ---- lazy engines ---------------------------------------------------------- */
  var loading = {};
  function loadScript(name, ready) {
    if (ready()) return Promise.resolve();
    if (loading[name]) return loading[name];
    var cfg = global.PPBagConfig || {};
    var src = cfg[name + 'Js'];
    if (!src) return Promise.reject(new Error('no ' + name));
    loading[name] = new Promise(function (resolve, reject) {
      var s = doc.createElement('script');
      s.src = src;
      s.async = true;
      s.onload = function () { ready() ? resolve() : reject(new Error(name + ' did not load')); };
      s.onerror = function () { loading[name] = null; reject(new Error(name + ' failed')); };
      doc.head.appendChild(s);
    });
    return loading[name];
  }
  function loadOrrery() {
    var cfg = global.PPBagConfig || {};
    if (cfg.orreryCss && !doc.querySelector('link[href*="pp-orrery.css"]')) {
      var l = doc.createElement('link');
      l.rel = 'stylesheet';
      l.href = cfg.orreryCss;
      doc.head.appendChild(l);
    }
    return loadScript('orrery', function () { return !!global.PPOrrery; });
  }
  function loadSkyCode() {
    return loadScript('skycode', function () { return !!(global.PPSkyCode && global.PPSkyCode.orbitDays); });
  }

  /* ---- thumbnails -------------------------------------------------------------- */
  var orreries = [];

  function drawPrint(host) {
    host.setAttribute('data-pp-drawn', 'pending');
    loadOrrery().then(function () {
      if (!host.isConnected) return;
      var inst = global.PPOrrery.create(host, {
        theme: host.getAttribute('data-theme') === 'white' ? 'white' : 'black',
        fit: 'poster',
        rules: true,
        date: host.getAttribute('data-date'),
        watermark: null,
        starDensity: 1,
        animateMs: 0
      });
      orreries.push(inst);
      host.setAttribute('data-pp-drawn', 'done');
    }).catch(function () { host.setAttribute('data-pp-drawn', 'fallback'); });
  }

  function drawCase(host) {
    var date = host.getAttribute('data-date');
    if (!validCaseDate(date)) { host.setAttribute('data-pp-drawn', 'fallback'); return; }
    host.setAttribute('data-pp-drawn', 'pending');
    var fonts = doc.fonts && doc.fonts.load ? doc.fonts.load("40px PPGlacial").catch(function () {}) : Promise.resolve();
    Promise.all([loadSkyCode(), fonts]).then(function () {
      if (!host.isConnected) return;
      var sky = global.PPSkyCode;
      var svg = caseSVG({
        date: date,
        edition: host.getAttribute('data-edition'),
        model: host.getAttribute('data-model'),
        days: sky.orbitDays(date),
        planets: sky.PLANETS
      });
      host.innerHTML = svg;
      host.setAttribute('data-pp-drawn', 'done');
    }).catch(function () { host.setAttribute('data-pp-drawn', 'fallback'); });
  }

  function drawIn(scope) {
    if (!scope) return;
    var hosts = scope.querySelectorAll('[data-pp-thumb]:not([data-pp-drawn])');
    for (var i = 0; i < hosts.length; i++) {
      var kind = hosts[i].getAttribute('data-pp-thumb');
      if (kind === 'print') drawPrint(hosts[i]);
      else if (kind === 'case') drawCase(hosts[i]);
    }
  }

  function sweep() {
    orreries = orreries.filter(function (inst) {
      if (inst.host && inst.host.isConnected) return true;
      try { inst.destroy(); } catch (_) { /* already gone */ }
      return false;
    });
  }

  var scheduled = false;
  function scan() {
    scheduled = false;
    sweep();
    var drawer = doc.querySelector('cart-drawer');
    /* The drawer draws only once it is open (or opening). */
    if (drawer && drawer.classList.contains('active')) drawIn(drawer);
    drawIn(doc.querySelector('cart-items'));
  }
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    (global.requestAnimationFrame || global.setTimeout)(scan);
  }

  /* Warm the engines when the shopper reaches for the bag. */
  function warm() {
    var drawer = doc.querySelector('cart-drawer');
    if (!drawer) return;
    if (drawer.querySelector('[data-pp-thumb="print"]')) loadOrrery().catch(function () {});
    if (drawer.querySelector('[data-pp-thumb="case"]')) loadSkyCode().catch(function () {});
  }

  /* Dawn traps focus on the drawer's first transitionend. If no transition
     runs (a browser setting, a slow frame), trap it here instead. */
  function ensureFocus(drawer) {
    setTimeout(function () {
      if (!drawer.classList.contains('active') || drawer.contains(doc.activeElement)) return;
      if (typeof global.trapFocus !== 'function') return;
      var container = drawer.classList.contains('is-empty')
        ? drawer.querySelector('.drawer__inner-empty')
        : doc.getElementById('CartDrawer');
      var target = drawer.querySelector('.drawer__inner') || drawer.querySelector('.drawer__close');
      if (container && target) global.trapFocus(container, target);
    }, 700);
  }

  function watch() {
    if (!global.MutationObserver) { schedule(); return; }
    var drawer = doc.querySelector('cart-drawer');
    if (drawer) {
      var wasActive = drawer.classList.contains('active');
      new MutationObserver(function () {
        schedule();
        var active = drawer.classList.contains('active');
        if (active && !wasActive) ensureFocus(drawer);
        wasActive = active;
      }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
      new MutationObserver(schedule).observe(drawer, { childList: true, subtree: true });
    }
    var page = doc.querySelector('cart-items');
    if (page) new MutationObserver(schedule).observe(page, { childList: true, subtree: true });
    schedule();
  }

  /* ---- the studios: open the bag after Add to cart ----------------------------- */
  var STUDIOS = 'pp-print-customizer, pp-case-customizer';

  function drawerReady() {
    var d = doc.querySelector('cart-drawer');
    return d && typeof d.renderContents === 'function' && typeof d.open === 'function' ? d : null;
  }

  /* Fetch the fresh bag and render it the way Dawn's product form does. */
  function openBag(trigger) {
    var drawer = drawerReady();
    if (!drawer || !global.fetch) return Promise.reject(new Error('no drawer'));
    return fetch(root() + '?sections=cart-drawer,cart-icon-bubble', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (r) {
      if (!r.ok) throw new Error('sections ' + r.status);
      return r.json();
    }).then(function (sections) {
      if (!sections || !sections['cart-drawer'] || sections['cart-drawer'].indexOf('id="CartDrawer"') === -1) {
        throw new Error('no drawer section');
      }
      var empty = sections['cart-drawer'].indexOf('data-pp-bag-empty') !== -1;
      drawer.classList.toggle('is-empty', empty);
      if (trigger && drawer.setActiveElement) drawer.setActiveElement(trigger);
      drawer.renderContents({ sections: sections });
    });
  }
  PPBag.openBag = openBag;

  function visible(el) { return !!(el && !el.hidden && el.offsetParent !== null); }

  /* The studios go to /cart after a successful add unless their config says
     otherwise. Just before a studio submits, we ask it to stay, then open the
     bag on its "added" event. Nothing else in the studio changes. */
  doc.addEventListener('submit', function (e) {
    var studio = e.target && e.target.closest ? e.target.closest(STUDIOS) : null;
    if (!studio || !studio.config || !drawerReady()) return;
    studio.config.navigateToCart = false;
    studio.ppBagOpens = true;
  }, true);

  function onAdded(e) {
    var studio = e.target && e.target.closest ? e.target.closest(STUDIOS) : null;
    if (!studio || !studio.ppBagOpens) return;
    var link = studio.querySelector('[data-cart-link], [data-cart]');
    var trigger = visible(link) ? link : studio.querySelector('[data-add]') || link;
    /* The studio re-enables its controls in a finally block; open after it. */
    setTimeout(function () {
      openBag(trigger).catch(function () { global.location.assign(cartUrl()); });
    }, 0);
  }
  doc.addEventListener('pp:cart-added', onAdded);
  doc.addEventListener('pp:case-added', onAdded);

  /* "View your cart" in either studio opens the bag in place. */
  doc.addEventListener('click', function (e) {
    var link = e.target.closest ? e.target.closest('[data-cart-link], pp-case-customizer [data-cart]') : null;
    if (!link || e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    if (!drawerReady()) return;
    e.preventDefault();
    openBag(link).catch(function () { global.location.assign(link.getAttribute('href') || cartUrl()); });
  });

  doc.addEventListener('pointerover', function (e) {
    if (e.target.closest && e.target.closest('#cart-icon-bubble')) warm();
  }, { passive: true });
  doc.addEventListener('focusin', function (e) {
    if (e.target.closest && e.target.closest('#cart-icon-bubble')) warm();
  });

  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', watch);
  else watch();
})(typeof window !== 'undefined' ? window : this);
